import {Component, effect, HostListener, inject, Input, OnInit, signal} from '@angular/core';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {ProyectoService} from '../../../proyectos/services/proyecto.service';
import {CatalogoService} from '../../../../shared/services/catalogo-service';
import {TramiteService} from '../../services/tramite.service';
import {LoginServices} from '../../../../auth/login/services/login.service';
import {SdetTramiteService} from '../../services/sdet-tramite.service';
import {MessageService} from 'primeng/api';
import {Location, NgForOf, NgIf} from '@angular/common';
import {DividerModule} from 'primeng/divider';
import {ToastModule} from 'primeng/toast';
import {Button} from 'primeng/button';
import {
    GeneralesProyectoComponent
} from '../../../proyectos/components/ver-proyecto/generales-proyecto/generales-proyecto.component';
import {TabViewModule} from 'primeng/tabview';
import {TramiteItem, TramiteTipoRequisitoItem,} from '../interfaces/tramites.interface';
import {ProyectoItem} from '../../../interfaces/proyecto.interface';
import {AccordionModule} from 'primeng/accordion';
import {
    SolicitudRequisitosComponent
} from '../../../../shared/components/solicitud-requisitos/solicitud-requisitos.component';
import {catchError, debounceTime, distinctUntilChanged, map, throwError,} from 'rxjs';
import {CardModule} from 'primeng/card';
import {TooltipModule} from 'primeng/tooltip';
import {TipoAreaEnum} from '../interfaces/formulario.interfaces';
import Swal from 'sweetalert2';
import {TarifarioInterface} from '../../../interfaces/pagos.interface';
import {switchMap, tap} from 'rxjs/operators';
import {InputTextModule} from 'primeng/inputtext';
import {PaginatorModule} from 'primeng/paginator';
import {SharedModule} from "../../../../shared/shared.module";
import CONSTANTS from 'src/utils/resources/constants';
import {useEffect} from 'src/utils/useEffect';
import {ShowButtonService} from 'src/utils/services/show-button.service';

@Component({
    selector: 'app-formulario-d',
    standalone: true,
    imports: [
        DividerModule,
        ToastModule,
        Button,
        GeneralesProyectoComponent,
        NgForOf,
        TabViewModule,
        AccordionModule,
        SolicitudRequisitosComponent,
        NgIf,
        CardModule,
        TooltipModule,
        InputTextModule,
        PaginatorModule,
        SharedModule,
    ],
    providers: [MessageService],
    templateUrl: './formulario-d.component.html',
    styleUrl: './formulario-d.component.scss',
})
export class FormularioDComponent implements OnInit {
    selected: TramiteItem = null!;
    proyectoAsignado: ProyectoItem[] = [];
    requisitoTipoTramite: TramiteTipoRequisitoItem[] = [];
    idProyecto: string | null = null;
    idTramite: string | null = null;
    tramiteCompleto: boolean = true;
    tarifa: number = 0;
    prjId$ = this.route.params.pipe(map((params) => params['idProyecto']));
    @Input() _showLoader: boolean = false;
    isLoading = signal(false);

    constructor(
        public router: Router,
        private route: ActivatedRoute,
        private proyectoService: ProyectoService,
        private catalogoService: CatalogoService,
        protected tramiteService: TramiteService,
        private loginServices: LoginServices,
        private sdetTramiteService: SdetTramiteService,
        private messageService: MessageService,
        private location: Location,
    ) {
        useEffect(() => {
            //verificar si this.proyecto() tiene datos y no es un objeto vacío
            if (this.proyecto() && Object.keys(this.proyecto()).length > 0) {
                if (this.consoleEnabled) {
                    console.log("Cambiando", this.proyecto())
                }
                //recopilacion de datos
                this.proyecto_nombre = this.proyecto().nombre
                //verificacion de datos
                this.is_proyect_rp = this.isProyectoRegistroProfesional()
            }
        }, [() => this.proyecto()]);
        useEffect(() => {
            const state = this.showButtonService.currentState();
            if (this.consoleEnabled) {
                console.log('Estado completo:', state)
            }
            if (state.message !== null) {
                Swal.fire({
                    icon: 'info',
                    confirmButtonText: 'Continuar',
                    title: state.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    showConfirmButton: true,
                    confirmButtonColor: '#3B82F6',
                    denyButtonColor: '#343a40',
                    text: "Complete su trámite subiendo los archivos correspondientes."
                })
                setTimeout(() => {
                    this.showButtonService.changeMessage(null)
                }, 3000);
            }
            if (state.visitado === false) {
                this.showButtonService.changeVisitado(true)
            }
        }, [() => this.showButtonService.currentState()]);
    }

    ngOnInit(): void {
        this.preFetchProyectoId();
        if (this.tramiteService.idProyecto()) {
            this.proyectoService
                .getGeneralesProyecto(this.tramiteService.idProyecto()!)
                .pipe(
                    catchError((error) => {
                        return throwError(error);
                    })
                )
                .subscribe((resp) => {
                    if (resp.status == 200) {
                        this.proyectoAsignado = resp.body!;
                        //Recuperamos el proyecto que estamos trabajando
                        this.proyecto.set(resp.body![0] as ProyectoItem)
                        this.getInfoAreaProyecto(
                            this.tramiteService.idProyecto()!,
                            this.proyectoAsignado[0].idTipoProyecto!,
                            'tipoareas'
                        );
                    }
                });
        }
        this.route.paramMap.subscribe((params: ParamMap) => {
            if (params.get('idTramite') != null) {
                this.idTramite = +params.get('idTramite')!
                    ? params.get('idTramite')
                    : null;
                if (this.idTramite != null) {
                    this.sdetTramiteService
                        .obtenerSdetItem(
                            this.tramiteService.idProyecto()!,
                            this.idTramite
                        )
                        .subscribe((resp) => {
                            this.selected = resp.body!;
                        });
                }
                if (params.get('idProyecto') != null) {
                    this.idProyecto = +params.get('idProyecto')!
                        ? params.get('idProyecto')
                        : null;
                    if (this.idProyecto != null) {
                        this.tramiteService.getRequisitosPorParametros(
                            this.idTramite!,
                            this.idProyecto,
                            this.requisitoTipoTramite
                        );
                    }
                }
            }
        });
    }

    private preFetchProyectoId() {
        console.log(`preFetchProyectoId`);
        this.prjId$.subscribe((id) => {
            if (id) {
                //load everything prj sequence.
                this.tramiteService.idProyecto.set(id);
            }
        });
        console.log(
            `params -> this.tramite.idProyecto  -> ${this.tramiteService.idProyecto()}`
        );
    }

    /**Metodo obtiene la informacion de areas y de la area total del proyecto previamente registrado en el FU.*
     */
    getInfoAreaProyecto(
        idProyecto: string,
        tipoProyecto: number,
        info: string | null
    ) {
        if ((info == 'tipoareas' && tipoProyecto != null) || undefined) {
            this.tramiteService
                .getObtenerTipoAreas(idProyecto!, [])
                .subscribe((resp) => {
                    this.tramiteService.tiposAreas.set(resp);
                    this.tramiteService.areaTotalSignal.set(
                        this.getAreaByTipo(TipoAreaEnum.Areaproyecto!)
                    );
                });
        }
    }

    onChangeCalcularTarifa() {
        let areaTotal = this.getAreaByTipo(TipoAreaEnum.Areaproyecto!);
        if (areaTotal != null && areaTotal != 0) {
            this._showLoader = true;
            this.calcularTarifa()
                .pipe(
                    debounceTime(200), // Debounce for 200 milliseconds
                    distinctUntilChanged(), // Only proceed if the query has changed
                    catchError((error) => {
                        let text = error.mensaje;
                        if (error.error && error.error.mensaje) {
                            text = error.error.mensaje; // Extract the custom message
                        } else if (error.message) {
                            text = error.message; // Fallback to the general error message
                        }
                        if (text.includes('api')) {
                            text =
                                'Ocurrió un error al procesar, intente mas tarde';
                        }
                        this.tramiteService.textTarifa = 'Calculo de tarifa no disponible en este momento.';
                        this._showLoader = false;
                        return throwError(error.statusText);
                    })
                )
                .subscribe({
                    next: (result) => {
                        if (result && result.body) {
                            let respuesta: TarifarioInterface[] | null =
                                result.body;
                            for (let i of respuesta!) {
                                if (i.total) {
                                    this.tramiteService.textTarifa = '';
                                    this.tarifa = parseFloat(
                                        i.total.toFixed(2)
                                    )!;
                                } else {
                                    this.tarifa = 0;
                                }
                                console.log(`this.tarifa = ${this.tarifa}`);
                                console.log(
                                    `institucion =${
                                        this.loginServices.session()?.perfil
                                            .idInstitucion
                                    }`
                                );
                            }
                            this._showLoader = false;
                        }
                    },
                    error: (error) => {
                        console.log(error);
                    },
                    complete: () => {
                    },
                });
        }
    }

    calcularTarifa() {
        console.log(`calcularTarifa()`);
        this.tramiteCompleto = true;
        let datos_calcular: TarifarioInterface[] = [
            {
                idEntorno: this.proyectoAsignado[0].idEntorno!,
                idTramite: parseInt(this.idTramite!, 10),
                idTipoArea: this.tramiteService
                    .tiposAreas()
                    .find(
                        (area) => area.idTipoArea === TipoAreaEnum.Areaproyecto
                    )?.idTipoArea!,
                area: this.getAreaByTipo(TipoAreaEnum.Areaproyecto!),
                idProyecto: this.tramiteService.idProyecto(),
                creadoPor: this.loginServices.session()?.perfil.usuario,
                idInstitucion:
                this.loginServices.session()?.perfil.idInstitucion,
                idSolicitud: this.proyectoAsignado[0].idSolicitud!,
            },
        ];
        return this.tramiteService.calcularTarifa(datos_calcular);
    }

    completarTramite() {
        this.obtenerSdetItemTramites();
    }

    /**
     * <h4>Obtener informacion tramite</h4>
     * <p>Este metodo obtiene la informacion actualizada del proyecto vinculado al tramite</p>
     * <ul>
     *     <li>se detecto que las estaditisticas para los requisitos de tipo form, text en la respuesta no obtiene los datos actualizados cuando se completan
     *     de ultimo estos requisitos.</li>
     *     <li>este metodo al darle click al boton finalizar obtiene la información del proyecto o solictud vinculado al tramite,
     *     para obtener la informacion completa y actualizada cuando el usuario finalice el tramite</li>
     *     <li>el trámite para ser completado con exito debe cumplir con la informacion y todos los requisitos obligatorios.</li>
     *     <li>si el trámite ya cuenta con informacion y los requitos obligatorios completos se procesa y finaliza el trámite.</li>
     * </ul>
     * @since 13/01/2025
     */
    obtenerSdetItemTramites() {
        const idProyecto = this.tramiteService.idProyecto();
        const idTramite = this.idTramite;
        if (!idProyecto || !idTramite) {
            console.error('Faltan datos necesarios: idProyecto o idTramite');
            return;
        }
        this.sdetTramiteService.obtenerSdetItem(idProyecto, idTramite)
            .pipe(
                tap((resp) => {
                    if (resp && resp.body) {
                        this.selected = resp.body;
                        this.procesarTramite();
                    } else {
                        throw new Error('No se encontró información en la primera respuesta');
                    }
                }),
                switchMap(() =>
                    this.sdetTramiteService.obtenerSdetItemAsignacionAutomatica(
                        idProyecto,
                        idTramite,
                        `${this.selected.idSolicitud}`
                    )
                ),
            )
            .subscribe({
                next: (resp) => {
                    this.procesarAsignacionAutomatica()
                    setTimeout(() => {
                        this.tramiteCompleto = true;
                        this.router.navigate(['/users/pagos/tramites', this.selected.idProyecto])
                            .then(() => this.isLoading.set(false));
                    }, 3000);
                },
                error: (err) => {
                    console.error('Este bloque puede no ser necesario si ya manejamos con catchError', err);
                }
            });
    }

    //TODO: Reescribir validaciones de este metodo, evaluar si es posible procesar en el backend. 28NOV2024
    procesarTramite() {
        this.tramiteCompleto = false;
        if (this.selected) {
            if (!(this.selected.qtycumplidos === this.selected.qtyrequeridos)) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: 'Favor debe cargar los archivos y documentos requeridos',
                    showDenyButton: true,
                    showConfirmButton: false,
                    denyButtonText: `Ok`,
                }).then((r) =>
                    console.log(
                        'Favor debe cargar los archivos y documentos requeridos'
                    )
                );
                return;
            }
        }
        if (this.tarifa == null) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Favor calcular la tarifa del trámite',
            });
            return;
        }
        //Procesar los datos segun el tipo de flujo
        this.validacionPrimerFlujoCompletarTramite();
        this.tramiteCompleto = true;
        console.log(
            `this.idProyecto= ${this.tramiteService.idProyecto()}, this.idTramite=${
                this.idTramite
            }`
        );
        console.log(`this.tarifa ->${this.tarifa}`);
    }

    procesarTramiteAsignacionAutomatica(success: boolean | null = false) {
        const is_cero = Number(this.selected.tarifaTramite) === 0;
        if (!is_cero) {
            if (success) {
                Swal.fire({
                    icon: 'info',
                    title: 'Solicitud asignada para evaluacion',
                    text: 'Complete los pagos en caso de ser necesario',
                    showDenyButton: false,
                    showConfirmButton: true,
                    confirmButtonText: `Ok`,
                }).then((r) =>
                    console.log("Solicitud Asignada para evaluacion")
                );
            }
        } else {
            if (success) {
                Swal.fire({
                    icon: 'info',
                    title: 'Solicitud asignada para evaluacion',
                    text: " Favor esperar notificacion del evaluador en su correo electronico  ", //mensaje que indica que los paggos han sido procesados
                    showDenyButton: false,
                    showConfirmButton: true,
                    confirmButtonText: `Ok`,
                }).then((r) =>
                    console.log("Solicitud Asignada para evaluacion")
                );
            }
        }
    }

    validacionPrimerFlujoCompletarTramite() {
        this._showLoader = true;
        console.log('select->', this.selected);
        this.tramiteService
            .completeFormProcess(this.selected)
            .pipe(
                tap((_) => console.log('SDet actualizado correctamente')),
                debounceTime(1000), // Debounce for 1000 milliseconds = 1 sec                            distinctUntilChanged(), // Only proceed if the query has changed
                switchMap((query) =>
                    this.tramiteService.completeFormProcess(this.selected)
                ),
                catchError((error) => {
                    return throwError(() => error);
                })
            )
            .subscribe((resp) => {
                if (resp.status == 200 || resp.status == 201) {
                    this._showLoader = false;
                    const id = this.selected.idProyecto
                        ? this.selected.idProyecto
                        : 0;
                    this.router
                        .navigate(['/users/pagos/tramites', id])
                        .then(() => {
                            console.log(
                                `tramites done` +
                                JSON.stringify(
                                    this.route.snapshot.queryParams
                                )
                            );
                        });
                }
            });
    }

    getAreaByTipo(tipo: TipoAreaEnum) {
        return this.tramiteService
            .tiposAreas()
            .find((area) => area.idTipoArea === tipo)?.area!;
    }

    /**
     Este metodo verifica si el id de un proyecto existe antes de finalizar el tramite
     y tambien hace un update cuando se agrega un nuevo proyecto de tipo flujo 2
     */
    validacionBotonCompletarTramite(): boolean {
        return this.tramiteService.idProyecto() == null;
    }

    goBack(): void {
        this.location.back();
    }

    onReceiveTramite(selected: TramiteItem): void {
        this.selected = selected;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        console.log('Page refresh detected');
        this.tramiteService.idProyecto.set(null);
        this.tramiteService.resetStatus();
    }

    /**Metodo que permite hacer el calculo de la tarifa de forma automatica siempre y cuando la tarifa no este vacia*/
    areaTotalEffect = effect(
        () => {
            if (
                (this.tramiteService.areaTotalSignal() !== 0 &&
                    this.tramiteService.areaTotalSignal() !== null) ||
                (this.proyectoAsignado.length > 0 &&
                    this.proyectoAsignado[0]?.idEntorno !== undefined &&
                    this.tramiteService.tiposAreas().length > 0)
            ) {
                setTimeout(() => {
                    this.onChangeCalcularTarifa();
                }, 200);
            }
        },
        {allowSignalWrites: true}
    );

    procesarTramiteSinCosto() {
        if (this.isLoading()) return
        this.isLoading.set(true);
        this.tramiteCompleto = false;
        // console.log('this.selected', this.selected)
        // console.log('this.selected pendientes', this.selected.qtypendientes)
        if (this.selected.qtypendientes > 0) {
            Swal.fire({
                title: 'Requisitos Incompletos',
                text: `Por favor complete los requisitos pendientes`,
                icon: 'warning',
            }).then(() => this.isLoading.set(false));
            return;
        }
        this.procesarAsignacionAutomatica()
    }

    /**
     * Metodo que procesa la asignacion automatica del tramite, este metodo se ejecuta cuando el
     * tramite no tiene costo y se asigna automaticamente al evaluador.
     * */
    procesarAsignacionAutomatica() {
        if (this.is_proyect_rp) {
            this.sdetTramiteService
                .obtenerSdetItemAsignacionAutomatica(this.tramiteService.idProyecto()!, this.idTramite!, `${this.selected.idSolicitud}`)
                .subscribe({
                    next: (resp) => {
                        if (resp) {
                            const message = resp.body;
                            if (message) {
                                this.procesarTramiteAsignacionAutomatica(message);
                                setTimeout(() => {
                                    this.tramiteCompleto = true;
                                    this.router.navigate([
                                        '/users/pagos/tramites',
                                        this.selected.idProyecto,
                                    ]).then(() => this.isLoading.set(false));
                                }, 3000);
                            } else {
                                setTimeout(() => {
                                    this.tramiteCompleto = true;
                                    this.router.navigate([
                                        '/users/pagos/tramites',
                                        this.selected.idProyecto,
                                    ]).then(() => this.isLoading.set(false));
                                }, 3000);
                            }
                        }
                    },
                    error: (error) => {
                        console.log(error);
                    },
                    complete: () => {
                    },
                });
        }
    }

    static rp_tramite: string = 'RP_';
    /** Usualmente definidos para recibir los datos de los inputs o datos cambiantes por rastreo signals */
    private consoleEnabled: boolean = CONSTANTS.consoleEnabled; // Cambiar a false para desactivar los logs de consola
    private proyecto = signal({} as ProyectoItem)
    /** Usualmente definidos para ser utilizados en el html */
    public proyecto_nombre: string = "";
    public is_proyect_rp: boolean = false;
    private showButtonService = inject(ShowButtonService);

    /* validar si en seleccionado el nombre inicia con {RP_} o no */
    isProyectoRegistroProfesional(): boolean {
        return this.proyecto_nombre.startsWith(FormularioDComponent.rp_tramite)
    }
}
